import * as dayjs from 'dayjs';

import { CallDirection, CallStatus, CallType } from './call-history.model';

export interface IFilter {
  name: string;
  type: string;
  options?: any[];
  unremovable?: boolean;
  unit?: string;
  default?: any;
}

export enum FilterType {
  TEXT = 'text',
  DATE = 'date',
  DATE_TIME = 'datetime',
  DROPDOWN = 'dropdown',
  DID = 'did',
  USER = 'user',
  INTERVAL = 'interval',
  TIMEZONE = 'timezone',
}

export interface IInterval {
  from: number;
  to: number;
}

export enum FilterBoolean {
  yes = 'yes',
  no = 'no',
}

export const defaultUsedFilters: IFilter[] = [
  {
    name: 'date_time_ranges',
    type: FilterType.DATE_TIME,
    unremovable: true,
    default: [
      {
        from: dayjs().subtract(1, 'month').toISOString(),
        to: new Date().toISOString(),
        from_time: '00:00',
        to_time: '23:59',
      },
    ],
  },
  {
    name: 'timezone',
    type: FilterType.TIMEZONE,
    unremovable: true,
  },
];

export const filters: IFilter[] = [
  {
    name: 'did_number',
    type: FilterType.DID,
  },
  {
    name: 'status',
    type: FilterType.DROPDOWN,
    options: [CallStatus.answered, CallStatus.unanswered],
  },
  {
    name: 'direction',
    type: FilterType.DROPDOWN,
    options: [CallDirection.inbound, CallDirection.outbound, CallDirection.internal],
  },
  {
    name: 'event_types',
    type: FilterType.DROPDOWN,
    options: [CallType.phone_call, CallType.click_to_call, CallType.fax_call, CallType.whatsapp],
  },
  {
    name: 'duration',
    type: FilterType.INTERVAL,
    unit: 'minutes',
  },
  {
    name: 'ring_time',
    type: FilterType.INTERVAL,
    unit: 'seconds',
  },
  {
    name: 'sentiment_score',
    type: FilterType.INTERVAL,
  },
  {
    name: 'destination_name',
    type: FilterType.TEXT,
  },
  {
    name: 'destination_number',
    type: FilterType.TEXT,
  },
  {
    name: 'originator_name',
    type: FilterType.TEXT,
  },
  {
    name: 'originator_number',
    type: FilterType.TEXT,
  },
  {
    name: 'answerer_name',
    type: FilterType.TEXT,
  },
  {
    name: 'answerer_number',
    type: FilterType.TEXT,
  },
  {
    name: 'voicemail',
    type: FilterType.DROPDOWN,
    options: [FilterBoolean.yes, FilterBoolean.no],
  },
  {
    name: 'recorded',
    type: FilterType.DROPDOWN,
    options: [FilterBoolean.yes, FilterBoolean.no],
  },
  {
    name: 'with_sms',
    type: FilterType.DROPDOWN,
    options: [FilterBoolean.yes, FilterBoolean.no],
  },
  {
    name: 'is_ai_agent',
    type: FilterType.DROPDOWN,
    options: [FilterBoolean.yes, FilterBoolean.no],
  },
  {
    name: 'user',
    type: FilterType.USER,
  },
];

export interface IDateTime {
  from: string;
  from_time: string;
  to: string;
  to_time: string;
}
